import React from 'react';
import PropTypes from 'prop-types';
import Login from './Login';
import Profile from './Profile';
import Modal from './Modal';
import './LoginModal.css';

export default function LoginModal(props) {
  const isCloseable = !props.isLoading && props.page !== 'profile';
  const onRequestClose = isCloseable ? props.onRequestClose : () => {};

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={onRequestClose}
      className={`${props.page}-modal`}
      showCloseButton={isCloseable}
    >
      {props.page === 'login' ? <Login {...props} /> : <Profile {...props} />}
    </Modal>
  );
}

LoginModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  isLoadingProfiles: PropTypes.bool,
  isManagingProfiles: PropTypes.bool,
  page: PropTypes.oneOf(['login', 'profile']),
  onRequestClose: PropTypes.func.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
  ...Login.PropTypes
};



// WEBPACK FOOTER //
// ./src/components/LoginModal.js